import { gatewayApiClient } from '../../_shared/api/gatewayApiClient';
import type { TargetRow } from '../types/target';

/**
 * #621 — 실 BE 계약: GET /targets → GatewayTargetResponse[] (페이징/쿼리 파라미터 없음, 전체
 * 서비스 대상 전역 목록). 등록/수정/삭제/가중치 벌크변경 엔드포인트는 BE 에 존재하지 않는다 —
 * 필터링은 FE 클라이언트 사이드에서만 수행한다.
 */
export const targetsApi = {
  list: async (): Promise<TargetRow[]> => {
    const response = await gatewayApiClient.get<TargetRow[]>('/targets');
    return response.data;
  },
};
